<template>
  <div class="home pa-2">

    <div class="filters-container d-flex flex-row flex-wrap mx-3 align-center">
      <v-text-field v-model="filters.search_terms" label="Rechercher un participant" density="compact"
        hide-details></v-text-field>
      <div class="sexe-selector-container d-flex flex-row flex-wrap mx-3 my-2">
        <v-btn class="mx-1 border" elevation="0" :class="[filters.sexe == 'M' ? 'bg-primary' : '']"
          @click="filters.sexe = 'M'"><v-icon icon="mdi-human-male"></v-icon></v-btn>
        <v-btn class="mx-1 border" elevation="0" :class="[filters.sexe == 'F' ? 'bg-primary' : '']"
          @click="filters.sexe = 'F'"><v-icon icon="mdi-human-female"></v-icon></v-btn>
      </div>
      <div class="sexe-selector-container d-flex flex-row flex-wrap mx-3 my-2">
        <v-btn class="mx-1 border" elevation="0" :class="[filters.sortBy == 'scratch' ? 'bg-primary' : '']"
          @click="filters.sortBy = 'scratch'">Clt Scratch</v-btn>
        <v-btn class="mx-1 border" elevation="0" :class="[filters.sortBy == 'categorie' ? 'bg-primary' : '']"
          @click="filters.sortBy = 'categorie'">Clt Catégorie</v-btn>
      </div>
    </div>



    <v-data-table class="result-table mt-5" v-model:expanded="expanded" :headers="headers" :items="runners"
      :key="key_render_table" show-expand :loading="$store.state.loading" density="compact" items-per-page="0"
      no-data-text="Aucun résultat ne correspond à votre recherche">



      <template v-slot:item="{ item }">
        <tr>
          <td>
            {{ item.classement }} <v-icon icon="mdi-medal-outline" v-if="item.classement <= 5"
              :color="get_medal_color(item.classement)"></v-icon>


          </td>
          <td>
            {{ item.classement_par_cat }}{{ item.categorie }} <v-icon icon=" mdi-medal-outline"
              :color="get_medal_color(item.classement_par_cat)" v-if="item.classement_par_cat <= 3"></v-icon>
          </td>
          <td class="font-weight-bold">
            <img class="flag mr-1" :src="'https://sportips.fr/live/img/Flags/' + item.nation + '.jpg'" />

            {{ item.nom.toUpperCase() }} {{
              item.prenom.charAt(0).toUpperCase() + item.prenom.slice(1).toLowerCase() }}
          </td>
          <td>{{ item.club }}</td>
          <td class="font-weight-bold">{{ item.points_scratch }}pts</td>
          <td class="font-weight-bold">{{ item.points_cat }}pts</td>
          <td><v-btn variant="text" color="primary" prepend-icon="mdi-plus" @click="expandthis(item.id)"
              size="small">Détails</v-btn>
          </td>

        </tr>
      </template>
      <template v-slot:expanded-row="{ columns, item }">
        <tr>
          <td class="px-0" :colspan="columns.length">
            <DetailsResultats :item="item"></DetailsResultats>
          </td>
        </tr>


      </template>

      <template v-slot:loading>
        <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
      </template>
    </v-data-table>

  </div>
</template>

<script>
import DetailsResultats from '@/components/DetailsResultats.vue';

export default {
  name: 'HomeView',
  components: {
    DetailsResultats


  },
  data() {
    return {
      expanded: [],
      headers: [

        { title: 'Clt Scratch', value: 'classement', class: 'primary' },
        { title: 'Clt Cat.', value: 'classement_par_cat' },
        { title: 'Nom', value: 'nom' },
        { title: 'Club', value: 'club' },
        { title: 'Points Scratch', value: 'points_scratch' },
        { title: 'Points catégorie', value: 'points_cat' },
        { title: 'Détails', value: "details", key: 'data-table-expand' },
      ],

      filters: {
        search_terms: '',
        sortBy: 'scratch',
        sexe: 'M',
      }
    }
  },
  computed: {
    key_render_table() {
      return this.runners.length + this.filters.sortBy + this.filters.sexe;
    },
    runners() {
      if (!this.$store.state.challenge) return [];
      if (!this.$store.state.challenge.coureurs) return [];
      let runners = this.$store.state.challenge.coureurs;
      // sort runners by classement
      runners.sort((a, b) => {
        return a.classement - b.classement;
      });
      if (this.filters.search_terms != '') {
        runners = runners.filter(runner => {
          return runner.nom.toLowerCase().includes(this.filters.search_terms.toLowerCase()) || runner.prenom.toLowerCase().includes(this.filters.search_terms.toLowerCase());
        });
      }
      if (this.filters.sexe) {
        runners = runners.filter(runner => runner.sexe === this.filters.sexe);
      }
      if (this.filters.sortBy == 'scratch') {
        runners.sort((a, b) => {
          return a.classement - b.classement;
        });
        runners = runners.filter(runner => parseInt(runner.points_scratch) > 0);
      }
      if (this.filters.sortBy == 'categorie') {
        runners.sort((a, b) => {
          return a.classement_par_cat - b.classement_par_cat;
        });
        runners = runners.filter(runner => parseInt(runner.points_cat) > 0);
      }
      return runners;
    }
  },
  methods: {
    get_medal_color(classement) {
      if (classement) {
        return "secondary";
      }
      return "secondary";

    },
    expandthis(id) {
      if (this.expanded.includes(id)) {
        this.expanded = this.expanded.filter(exp => exp !== id);
      } else {
        this.expanded.push(id);
      }
    }
  },
  async created() {
    await this.$store.dispatch('fetchChallenge');
  }
}
</script>

<style>
.result-table thead th {
  background-color: #027887 !important;
  color: white;
  font-weight: 700 !important;
  white-space: nowrap;
}

.result-table tbody td {

  white-space: nowrap;
}

.result-table tbody td .v-card {

  white-space: normal !important;
}

.flag {
  height: 12px;
  width: auto;
}

.v-data-table-footer {
  display: none !important;
}
</style>
